import { gql } from '@apollo/client';

export const ASSET_HIERARCHIES_MAPPED = gql`
  subscription assetHierarchiesMapped {
    assetHierarchiesMapped {
      sourceHierarchyId
      destinationHierarchyId
    }
  }
`;

export const ASSET_HIERARCHY_IMAGE_SET = gql`
  subscription assetHierarchyImageSet($id: Int!) {
    assetHierarchyImageSet(id: $id) {
      id
      imageUrl
    }
  }
`;

export const ASSET_HIERARCHY_IMAGE_ACQUIRED = gql`
  subscription assetHierarchyImageAcquired {
    assetHierarchyImageAcquired {
      hierarchyId
      url
    }
  }
`;

export const SYNCHRONIZE_ASSET_COMPLETED = gql`
  subscription synchronizeAssetCompleted {
    synchronizeAssetCompleted {
      hierarchyId
      itemId
      message
    }
  }
`;

export const SYNCHRONIZE_ASSET_FAILED = gql`
  subscription synchronizeAssetFailed {
    synchronizeAssetFailed {
      assetHierarchyId
      message
    }
  }
`;

export const SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_COMPLETED = gql`
  subscription synchronizeAssetImageOnDocumentsCompleted {
    synchronizeAssetImageOnDocumentsCompleted
  }
`;

export const SYNCHRONIZE_ASSET_IMAGE_ON_DOCUMENTS_FAILED = gql`
  subscription synchronizeAssetImageOnDocumentsFailed {
    synchronizeAssetImageOnDocumentsFailed {
      message
    }
  }
`;
